/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-04-19 20:11:59
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-16 14:51:42
*/

'use strict';

import { install } from 'babel-loader!./install.babel.js';

const Default = {};

Default.install = install;

export default Default;



// WEBPACK FOOTER //
// ./~/@souche-f2e/weidian-util-vue-layer/src/index.babel.js